export const Functions = {
  create: true,
  delete: false,
  detail: true,
  search: true
};
export const PageName = '津贴管理';